import { Injectable, inject } from "@angular/core";
import { catchError, Observable, of } from "rxjs";
import { GroupByPayload, ProjectionOperation } from "../models/vcloud-api";
import { EventsService } from "./events.service";
import { VCloudSmartApiService } from "./v-cloud-smart-api.service";
import { PaginationState } from "../../shared/models/pagination";
import { TableRow } from "../models/common-table";
import { DEFAULT_PAGE_SIZE } from "../../shared/constant/tables";

@Injectable({
  providedIn: "root",
})
export class PaginationService {
  private eventsService = inject(EventsService);
  private vcloudApi = inject(VCloudSmartApiService);

  public defaultLimit: number = 4900;
  private activePage: number = 0;
  private lastLoadedPage: number = -1;

  public getTableRows(request: any): Observable<{ Results: { Group: string[]; Value: any[] }[] }> {
    const requestBody: GroupByPayload = {
      ...request.RequestBody,
      GroupBy: undefined,
      GroupByV2: undefined,
      Projection: [
        {
          Attribute: request.Attribute,
          Operation: ProjectionOperation.count,
          Distinct: true,
        },
      ],
      Filters: request.Filters,
    };
    return this.vcloudApi.groupBy(requestBody).pipe(
      catchError((err) => {
        this.eventsService.displayErrorToUser(err, "Get Table Rows");
        return of({ Results: [] });
      }),
    );
  }

  public handlePagination(state: PaginationState<TableRow>) {
    if (this.lastLoadedPage !== -1 && state.pageNumber < this.lastLoadedPage) {
      return;
    } else {
      this.activePage = state.pageNumber;
      this.lastLoadedPage = this.lastLoadedPage + this.defaultLimit / DEFAULT_PAGE_SIZE - 1;
      return { isLoadData: true, activePage: this.activePage };
    }
  }
}
